import React from 'react';
import Section from '@components/Section';
import NoteView from '@components/Note';
import Note from '@models/Note';

export const NotesList = ({
  notes,
  creatingNewNote,
  currentlyEditingNote,
  clearNewNote,
  deleteNote,
  setCurrentlyEditing,
  clearCurrentlyEditing,
  readOnly,
}: {
  notes: Note[];
  creatingNewNote?: boolean;
  currentlyEditingNote?: Note;
  clearNewNote?: () => void;
  deleteNote?: (note: Note) => void;
  setCurrentlyEditing?: (note: Note, e: any) => void;
  clearCurrentlyEditing?: () => void;
  readOnly?: boolean;
}) => {
  return (
    (notes.length > 0 || !!creatingNewNote) && (
      <Section>
        <Section.Title underline>Notes</Section.Title>
        {!creatingNewNote ? null : (
          <NoteView
            key="newNote"
            note={currentlyEditingNote}
            selected
            removeable
            onBlur={clearNewNote}
            onDelete={deleteNote}
          />
        )}
        {notes.map((note) => (
          <NoteView
            key={note.id}
            note={note}
            selected={note.isEqual(currentlyEditingNote)}
            onSelect={setCurrentlyEditing}
            onBlur={clearCurrentlyEditing}
            onDelete={deleteNote}
            readOnly={readOnly}
          />
        ))}
      </Section>
    )
  );
};
